import { Chip } from "@mui/material";
import type { AppointmentStatus } from "@/types/domain";

const map: Record<
  string,
  { label: string; color: "default" | "warning" | "success" | "error" | "info" | "primary" }
> = {
  PENDING: { label: "Awaiting payment", color: "warning" },
  CONFIRMED: { label: "Confirmed", color: "success" },
  CANCELLED: { label: "Cancelled", color: "error" },
  CANCELLED_BY_PATIENT: { label: "Cancelled by patient", color: "error" },
  CANCELLED_BY_DOCTOR: { label: "Cancelled by doctor", color: "error" },
  CANCELLED_BY_ADMIN: { label: "Cancelled by admin", color: "error" },
  COMPLETED: { label: "Completed", color: "info" },
  NO_SHOW_PATIENT: { label: "Patient no-show", color: "error" },
  NO_SHOW_DOCTOR: { label: "Doctor no-show", color: "error" },
  RESCHEDULED: { label: "Rescheduled", color: "primary" },
  EXPIRED: { label: "Expired (unpaid)", color: "default" },
};

export function AppointmentStatusBadge({
  status,
}: {
  status: AppointmentStatus;
}) {
  const m = map[status] ?? { label: status, color: "default" as const };
  return <Chip size="small" label={m.label} color={m.color} sx={{ fontWeight: 700 }} />;
}
